import React, { PropTypes } from 'react';
import { injectIntl, intlShape } from 'react-intl';
import { connect } from 'react-redux';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { bindActionCreators } from 'redux';
import isEqual from 'lodash/isEqual';

import BcReactComponent from '@bibliocommons/base-bc-react-component';
import { paginationShape } from '@bibliocommons/bc-prop-types';
import DocumentHeadContainer from '../DocumentHeadContainer';
import { currentAccountSelector } from '../../selectors/AuthSelector';
import { getCurrentCheckouts, getPagination, getCheckedoutStatus } from '../../selectors/CheckoutSelector';
import * as CheckoutActions from '../../actions/CheckoutActions';
import CheckedOutPrintList from '../../components/borrowing/checkouts/CheckedOutPrintList';

class PrintCheckedOutContainer extends BcReactComponent {
  static fetchInitialData(params, query, store) {
    const account = currentAccountSelector(store.getState());
    const accountId = account && account.get('id');

    return [store.dispatch(CheckoutActions.fetchCheckouts({ accountId, ...query, ...params }))];
  }

  componentWillUpdate(nextProps) {
    const { location } = this.props;

    if (!isEqual(location.search, nextProps.location.search)) {
      this.props.checkoutActions.fetchCheckouts({
        accountId: nextProps.accountId,
        ...nextProps.router.params,
        ...nextProps.location.query
      });
    }
  }

  render() {
    const { intl, ...props } = this.props;

    return (
      <div className="cp-print-list">
        <DocumentHeadContainer pageTitle={intl.formatMessage({ id: 'section_title_checkedout' })} />
        <CheckedOutPrintList {...props} />
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const items = getCurrentCheckouts(state, ownProps);
  const pagination = getPagination(state, ownProps);
  const isFetching = getCheckedoutStatus(state).get('fetching', false);
  const account = currentAccountSelector(state);
  const accountId = account && account.get('id');

  return {
    items,
    pagination,
    isFetching,
    accountId
  };
};


const mapDispatchToProps = dispatch => ({
  checkoutActions: bindActionCreators(CheckoutActions, dispatch)
});

PrintCheckedOutContainer.propTypes = {
  intl: intlShape,
  items: ImmutablePropTypes.list,
  isFetching: PropTypes.bool,
  pagination: paginationShape,
  accountId: PropTypes.number
};

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(PrintCheckedOutContainer));



// WEBPACK FOOTER //
// ./app/containers/print/PrintCheckedOutContainer.jsx